<script setup>
import SideFilter from '../SideFilter.vue'

import { useStore } from '@/utils/VuexHelpers'
import { computed, getCurrentInstance, ref } from 'vue'

const vm = getCurrentInstance().proxy

const procCostSideFilter = ref(null)

const store = useStore()
const filtersProcCost = computed(() => store.getters.filtersProcCost)

const updateWeekFilter = (dateRange) => {
  const { weekNr, startDay, endDay, year } = dateRange

  store.commit('SET_FILTER_PROC_COST', {
    field: 'week',
    value: weekNr
  })
  store.commit('SET_FILTER_PROC_COST', {
    field: 'date_start',
    value: startDay
  })
  store.commit('SET_FILTER_PROC_COST', {
    field: 'date_end',
    value: endDay
  })

  if (filtersProcCost.value.year.value !== year) {
    store.commit('SET_FILTER_PROC_COST', {
      field: 'year',
      value: year
    })
  }
  store.dispatch('fetchProcCost', { vm })
}

const updateYearFilter = (data) => {
  const { year } = data
  const cleanYear = parseInt(year.trim())

  if (cleanYear === filtersProcCost.value.year.value) return

  store.commit('SET_FILTER_PROC_COST', { field: 'year', value: cleanYear })
  if (!filtersProcCost.value.week.value) return

  procCostSideFilter.value.generateWeekDays(
    filtersProcCost.value.week.value,
    cleanYear
  )
}

const resetFilters = () => {
  store.dispatch('clearFiltersProcCost')
  store.dispatch('fetchProcCost', { vm })
}
</script>

<template>
  <SideFilter
    :filterList="filtersProcCost"
    @inputWeek="updateWeekFilter"
    @inputYear="updateYearFilter"
    @clear="resetFilters"
    ref="procCostSideFilter"
    class="mt-0"
  />
</template>
